import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLogged = useSelector(state => state.user.isAuthenticated);
  return <Route {...rest} render={props => (isLogged ? <Component {...props} /> : <Redirect to="/login" />)} />;
};
